export function preloadDecodedImage(src: string, fallbackSrc?: string): Promise<string> {
  return new Promise((resolve) => {
    if (!src) {
      if (fallbackSrc) {
        void preloadDecodedImage(fallbackSrc).then(resolve)
        return
      }
      resolve(src)
      return
    }

    const img = new window.Image()
    img.decoding = 'async'

    const finish = (url: string) => resolve(url)

    const decodeThen = (url: string) => {
      if (typeof img.decode === 'function') {
        void img
          .decode()
          .then(() => finish(url))
          .catch(() => finish(url))
        return
      }
      finish(url)
    }

    const fail = () => {
      if (fallbackSrc && fallbackSrc !== src) {
        void preloadDecodedImage(fallbackSrc).then(finish)
        return
      }
      finish(src)
    }

    img.onload = () => decodeThen(src)
    img.onerror = fail
    img.src = src

    if (img.complete && img.naturalWidth > 0) {
      decodeThen(src)
    }
  })
}
